import { Injectable } from '@angular/core';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { Observable } from 'rxjs';
import {
  HubFrequentDriverListSearchCriteria,
  HubFrequentDriverSearchCriteria,
} from '../../models/hub-frequent-driver-list.model';
import {
  HubFrequentDriverListInitialState,
  HubFrequentDriverListItemDelete,
  HubFrequentDriverListLoad,
  HubFrequentDriverListItemCreate,
  HubFrequentDriversSearch,
  HubFrequentDriverListItemSave,
  HubFrequentDriversClearSearch,
} from './hub-frequent-driver-list.actions';
import { HubFrequentDriverListState, HubFrequentDriverListStateModel } from './hub-frequent-driver-list.state';
import { HubFrequentDriverModel } from '../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class HubFrequentDriverListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<HubFrequentDriverListStateModel> = this.store.select(HubFrequentDriverListState.getState);
  autocompletedHubDrivers$: Observable<HubFrequentDriverModel[]> = this.store.select(
    HubFrequentDriverListState.getAutocompletedHubDrivers,
  );
  loaded$: Observable<boolean> = this.store.select(HubFrequentDriverListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.DriverList)
      .subscribe((searchCriteria: HubFrequentDriverListSearchCriteria) => {
        this.store.dispatch(new HubFrequentDriverListLoad(searchCriteria));
      });
  }

  searchDriver(hubId: number, searchCriteria: HubFrequentDriverSearchCriteria, carrierExtId: string): void {
    const searchCriteriaObj = { ...searchCriteria };

    if (carrierExtId) {
      searchCriteriaObj.carrierExtId = carrierExtId;

      this.store.dispatch(new HubFrequentDriversSearch(hubId, searchCriteriaObj));
    } else {
      this.setInitialStateForAutocomplete();
    }
  }

  createDriver(driver: HubFrequentDriverModel): void {
    this.store.dispatch(new HubFrequentDriverListItemCreate(driver));
  }

  //TODO: check where it's used
  saveDriver(driver: HubFrequentDriverModel, dialogRef: MatDialogRef<unknown>): void {
    this.store.dispatch(new HubFrequentDriverListItemSave(driver, dialogRef));
  }

  deleteHub(
    hubId: number,
    driverId: number,
    dialogRef: MatDialogRef<unknown>,
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
  ): void {
    this.store.dispatch(
      new HubFrequentDriverListItemDelete({
        hubId,
        driverId,
        dialogRef,
        dialog,
      }),
    );
  }

  setInitialStateForAutocomplete(): void {
    this.store.dispatch(new HubFrequentDriversClearSearch());
  }

  setInitialState(): void {
    this.store.dispatch(new HubFrequentDriverListInitialState());
  }

  private getCountOfFilledProperties(obj: object): number {
    return Object.keys(obj).filter((key: string) => !!obj[key]).length;
  }
}
